import { ModuleWithProviders, NgModule, Optional, SkipSelf, } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

import { SnackBarMessageComponent } from '@shared/components/snack-bar-message.component';
import { ApiBasketService } from './services/cart/api-basket.service';
import { ShoppingCartService } from './services/cart/shopping-cart.service';
import { ApiOrderService } from '@shared/services/cart/api-order.service';
import { OrderService } from '@shared/services/cart/order.service';
import { FiltersService } from '@shared/services/filters/filters.service';
import { OverlayService } from '@shared/services/overlay.service';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [CommonModule, TranslateModule, FormsModule],
  providers: [ApiBasketService, ApiOrderService, OverlayService, OrderService],
  declarations: [SnackBarMessageComponent],
  exports: [
    SnackBarMessageComponent,
    FormsModule,
  ],
})
export class SharedModule {
  constructor(@Optional() @SkipSelf() parentModule: SharedModule) {
    // Import guard
    if (parentModule) {
      throw new Error(
        `${parentModule} has already been loaded. Import Core module in the AppModule only.`
      );
    }
  }

  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [ShoppingCartService, FiltersService],
    };
  }
}
